import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const CollectionBuilderContainer = styled.div`
  &&&&&&&&&&& {
    display: flex;
    flex-direction: column;
    gap: ${spacing.half};
    .catalogsDropdownContainer {
      /** conversion from a .css file */
      width: 100%;
      opacity: 1;
      transition: opacity 0.2s 0.2s;
      &.loadingHeader {
        opacity: 0;
        transition: opacity 0s;
      }
    }
    [data-role='queryBuilder'] + div > div > div {
      /** conversion from a .css file */
      padding: ${spacing.base};
      background: #eff0f0;
    }
  }
`;

export const PageHeaderInlineEditContainer = styled.div`
  max-width: 40ch;
`;
